<template>
  <div
    :class="['hamburgerMenu', { 'hamburgerMenu--bordered': bordered }]"
    @click="toggleMenu({ type: menuName })"
  >
    <div class="hamburgerMenu__icon">
      <span />
      <span />
      <span />
    </div>
    <span v-if="text" class="hamburgerMenu__text">
      {{ text }}
    </span>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'HamburgerMenu',
  props: {
    text: {
      type: String,
      default: '',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    menuName: {
      type: String,
      default: 'category',
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: 'layout/toggleMenuOpened',
    }),
  },
};
</script>

<style lang="scss">
.hamburgerMenu {
  display: none;
  cursor: pointer;

  &--bordered {
    padding: 1rem 2.5rem;
    border-radius: 4px;
    border: 1px solid $cAddLight;
  }

  @include rwd('large-laptop') {
    display: flex;
    align-items: center;
  }

  &__icon {
    span {
      display: block;
      margin: 4px 0;
      height: 2px;
      width: 20px;
      background-color: $cMain;
    }
  }

  &__text {
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    color: $cAddDark02;
    margin-left: 1rem;
  }
}
</style>
